import { useState } from "react";
import { cn } from "@/lib/cn";

function getInitials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "";
  if (parts.length === 1) return parts[0]?.[0]?.toUpperCase() ?? "";
  const last = parts.at(-1);
  return `${parts[0]?.[0]?.toUpperCase() ?? ""}${last?.[0]?.toUpperCase() ?? ""}`;
}

interface AvatarProps {
  src?: string;
  alt?: string;
  name?: string;
  size?: number;
  className?: string;
  imgClassName?: string;
}

function Avatar({ src, alt, name = "", size = 36, className, imgClassName }: AvatarProps) {
  const [imgError, setImgError] = useState(false);
  const showImage = src && !imgError;
  const initials = getInitials(name);

  const sizeStyle = { width: size, height: size };
  const fontSize = Math.max(10, Math.round(size * 0.36));

  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center justify-center rounded-full",
        !showImage && "bg-electric-700 text-white font-semibold",
        className,
      )}
      style={sizeStyle}
    >
      {showImage ? (
        <img
          src={src}
          alt={alt ?? name}
          className={cn("h-full w-full rounded-full object-cover object-top", imgClassName)}
          onError={() => setImgError(true)}
        />
      ) : (
        <span style={{ fontSize }} aria-hidden={!!alt}>
          {initials}
        </span>
      )}
    </span>
  );
}

export { Avatar, type AvatarProps, getInitials };
